import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import InputBase from '@material-ui/core/InputBase'
import Paper from '@material-ui/core/Paper'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import SearchIcon from '@material-ui/icons/Search'

import NewTicketModal from '../NewTicketModalWecloud'
import TicketsList from '../TicketsListCustom'

import {
  Chip,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { AuthContext } from '../../context/Auth/AuthContext'
import useSettings from '../../hooks/useSettings'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'

import { Grid } from '@material-ui/core'
import Badge from '@material-ui/core/Badge'
import {
  Bot,
  CirclePlus,
  CircleX,
  Filter,
  Headset,
  History,
  RotateCw,
  UsersRound
} from 'lucide-react'
import { toast } from 'react-toastify'
import BottomNavbar from '../BottomNavBar'
import ChatMobile from '../ChatMobile'
import FilterTicketModal from '../FilterTicketModal'
import { InputSwitch } from '../InputSwitch'
import { useStyles } from './style'
import { SocketContext } from '../../context/Socket/SocketContext'
import { checkRole } from '../../helpers/checkRole'

const TicketsManagerTabs = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const history = useHistory()

  const [searchParam, setSearchParam] = useState('')
  const [tab] = useState('open')
  const [tabOpen, setTabOpen] = useState('open')
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false)
  const [filterModalOpen, setFilterModalOpen] = useState(false) //adicionado filter modal
  const [showAllTickets, setShowAllTickets] = useState(false)
  const searchInputRef = useRef()
  const { user } = useContext(AuthContext)

  const [openCount, setOpenCount] = useState(0)
  const [pendingCount, setPendingCount] = useState(0)

  const [botCount, setBotCount] = useState(0)
  const [groupsCount, setGroupsCount] = useState(0)
  const [closedCount, setClosedCount] = useState(0)

  const [, setOpenTotal] = useState(0)

  const userQueueIds =
    user.queues && Array.isArray(user.queues) ? user.queues.map(q => q.id) : []
  const [selectedQueueIds] = useState(userQueueIds || [])

  const { getSetting } = useSettings()
  const [showTabGroups, setShowTabGroups] = useState(false)

  const [initialTickets, setInitialTickets] = useState([])
  const [filteredTickets, setFilteredTickets] = useState([]) //Adicionado para filtrar os tickets
  const [activeFilters, setActiveFilters] = useState({
    searchParam: '',
    tags: [],
    users: [],
    departament: [],
    status: '',
    groups: ''
    // queueIds: []
  })

  const [showClosedTickets, setShowClosedTickets] = useState(() => {
    return localStorage.getItem('showClosedTickets') === 'true'
  })
  const [, setFoco] = useState(false)
  const [key, setKey] = useState(0)
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [showBotTab, setShowBotTab] = useState(false)

  const [unreadTabs, setUnreadTabs] = useState({
    open: false,
    pending: false,
    groups: false,
    chatbot: false,
    closed: false
  })

  const socketManager = useContext(SocketContext)

  useEffect(() => {
    let isMounted = true

    if (!socketManager) {
      return
    }

    const managedSocket =
      typeof socketManager.GetSocket === 'function'
        ? socketManager.GetSocket()
        : socketManager

    if (!managedSocket || typeof managedSocket.on !== 'function') {
      return
    }

    const companyId =
      socketManager.currentCompanyId ||
      (managedSocket.rawSocket?.io?.opts?.query?.token ? 2 : 2)

    const appMessageEvent = companyId
      ? `company-${companyId}-appMessage`
      : 'appMessage'
    const ticketEvent = companyId ? `company-${companyId}-ticket` : 'ticket'

    const handleGlobalUnread = data => {
      if (!isMounted) return

      console.log('[SocketDebug] Evento recebido no canal global:', data)

      const ticket = data?.ticket || data

      if (ticket) {
        const status = ticket.status

        let targetTab = status
        if (ticket.isGroup) {
          targetTab = 'groups'
        } else if (ticket.chatbot) {
          targetTab = 'chatbot'
        }

        if (targetTab && targetTab !== 'filtered') {
          if (ticket.unreadMessages > 0 || data.action === 'create') {
            console.log(
              `[SocketDebug] Marcando aba "${targetTab}" como não lida.`
            )
            setUnreadTabs(prev => ({
              ...prev,
              [targetTab]: true
            }))
          }
        }
      }
    }

    const unsubs = [
      managedSocket.on(appMessageEvent, handleGlobalUnread),
      managedSocket.on(ticketEvent, handleGlobalUnread)
    ]

    return () => {
      isMounted = false
      unsubs.forEach(unsubscribe => {
        if (typeof unsubscribe === 'function') {
          unsubscribe()
        }
      })
    }
  }, [socketManager])

  const handleChangeTabOpen = useCallback((e, newValue) => {
    setTabOpen(newValue)
    if (newValue !== 'filtered') {
      setUnreadTabs(prev => ({ ...prev, [newValue]: false }))
    }
  }, [])

  useEffect(() => {
    const handleSyncState = e => {
      const newValue =
        e.detail !== undefined
          ? e.detail
          : localStorage.getItem('showClosedTickets') === 'true'
      setShowClosedTickets(newValue)
    }

    window.addEventListener('storage_closed_tickets', handleSyncState)
    window.addEventListener('storage', handleSyncState)

    return () => {
      window.removeEventListener('storage_closed_tickets', handleSyncState)
      window.removeEventListener('storage', handleSyncState)
    }
  }, [])

  useEffect(() => {
    if (!showClosedTickets && tabOpen === 'closed') {
      setTabOpen('open')
    }
  }, [showClosedTickets, tabOpen])

  useEffect(() => {
    const hasBotPermission = user.queues?.some(q => q.isBot === true)
    const isSuper = user.super === true

    setShowBotTab(hasBotPermission || isSuper)
  }, [user])

  useEffect(() => {
    if (!areAllFiltersEmpty(activeFilters)) {
      setTabOpen('filtered')
    } else if (tabOpen === 'filtered') {
      setTabOpen('open')
    }
  }, [activeFilters])

  useEffect(() => {
    let isMounted = true
    const fetchInitialTickets = async () => {
      try {
        const { data } = await api.get('/tickets', {
          params: {
            status: 'open',
            showAll: true,
            userId: user.id
          }
        })
        if (isMounted) {
          setInitialTickets(data.tickets)
          setFilteredTickets(data.tickets)
        }
      } catch (error) {
        if (isMounted) {
          console.error('Erro ao carregar tickets iniciais:', error)
          toast.error('Erro ao carregar tickets')
        }
      }
    }
    fetchInitialTickets()

    return () => {
      isMounted = false
    }
  }, [user.id])

  useEffect(() => {
    Promise.all([getSetting('CheckMsgIsGroup'), getSetting('groupsTab')]).then(
      ([ignoreGroups, groupsTab]) => {
        setShowTabGroups(ignoreGroups === 'disabled' && groupsTab === 'enabled')
      }
    )
  }, [])

  useEffect(() => {
    let isMounted = true
    const loadUserData = async () => {
      try {
        const { data } = await api.get(`/users/${user.id}`)

        if (isMounted) {
          setFoco(data.foco || false)

          const isSuperUser = data.super === true
          const hasBotPermission = data.queues?.some(q => q.isBot === true)

          setShowBotTab(isSuperUser || hasBotPermission)
        }
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error)
      }
    }

    if (user.id) {
      loadUserData()
    }
    return () => {
      isMounted = false
    }
  }, [user.id])

  useEffect(() => {
    if (
      user.profile.toUpperCase() === 'ADMIN' ||
      checkRole(user, 'super') ||
      checkRole(user, 'gestor')
    ) {
      //console.log('User is admin, super or gestor:', user)
      setShowAllTickets(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (tab === 'search') {
      searchInputRef.current.focus()
    }
  }, [tab])

  useEffect(() => {
    if (!filterModalOpen) {
      setFilteredTickets([])
    }
  }, [filterModalOpen])

  let searchTimeout

  const handleClosedSwitchChange = event => {
    setShowClosedTickets(event.target.checked)
    if (!event.target.checked && tabOpen === 'closed') {
      setTabOpen('open')
    }
  }

  const statusLabels = {
    '': 'Todos',
    open: 'Ativos',
    pending: 'Pendentes',
    closed: 'Fechados'
  }

  const getFilterDisplayValue = (type, value) => {
    if (typeof value === 'object' && value !== null) {
      return value.name || value.id
    }
    if (type === 'status') {
      return statusLabels[value] || value
    }
    if (type === 'searchParam') {
      return `Busca: ${value}`
    }

    return value
  }

  const areAllFiltersEmpty = filters => {
    return Object.values(filters).every(value =>
      Array.isArray(value) ? value.length === 0 : !value
    )
  }

  const handleSearch = e => {
    const searchedTerm = e.target.value.toLowerCase()
    clearTimeout(searchTimeout)

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm)
    }, 500)
  }

  const handleFilter = async filterData => {
    try {
      setActiveFilters({
        searchParam: filterData.searchParam || '',
        tags: filterData.displayData?.tags || [],
        status: filterData.status || '',
        users: filterData.displayData?.users || [],
        groups: filterData.groups || '',
        departament: filterData.displayData?.departments || []
      })

      if (areAllFiltersEmpty(filterData)) {
        setFilteredTickets(initialTickets)
        return
      }

      const { data } = await api.get('/tickets', { params: filterData })

      setFilteredTickets(data.tickets)
      setTabOpen('filtered')
    } catch (error) {
      console.error('Erro:', error)
      toast.error('Erro ao filtrar tickets')
    }
  }

  const removeFilter = (type, value) => {
    const newFilters = { ...activeFilters }

    if (Array.isArray(newFilters[type])) {
      newFilters[type] = newFilters[type].filter(item => item.id !== value.id)
    } else {
      newFilters[type] = ''
    }

    // Se todos os filtros foram removidos, retorna ao estado inicial
    if (areAllFiltersEmpty(newFilters)) {
      setFilteredTickets(initialTickets)
      setActiveFilters(newFilters)
      return
    }

    // Caso contrário, aplica os filtros restantes
    const filterData = {
      searchParam: newFilters.searchParam || undefined,
      status: newFilters.status,
      showAll: true,
      userId: user.id,
      users: newFilters.users.length
        ? JSON.stringify(newFilters.users.map(u => u.id))
        : undefined,
      tags: newFilters.tags.length
        ? JSON.stringify(newFilters.tags.map(t => t.id))
        : undefined,
      departaments: newFilters.departament.length
        ? JSON.stringify(newFilters.departament.map(d => d.id))
        : undefined,
      groups: newFilters.groups || undefined,
      displayData: {
        tags: newFilters.tags,
        users: newFilters.users,
        departments: newFilters.departament
      }
    }

    // Remove propriedades undefined
    Object.keys(filterData).forEach(
      key => filterData[key] === undefined && delete filterData[key]
    )

    handleFilter(filterData)
  }

  const clearAllFilters = () => {
    setActiveFilters({
      searchParam: '',
      tags: [],
      users: [],
      departament: [],
      status: '',
      groups: ''
    })
    setFilteredTickets(initialTickets)
  }

  // const handleChangeTabOpen = (e, newValue) => {
  //   setTabOpen(newValue)
  // }

  const applyPanelStyle = status => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 }
    }
  }

  const handleCloseOrOpenTicket = ticket => {
    setNewTicketModalOpen(false)
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`)
    }
  }

  const handleCloseOrOpenFilter = () => {
    setFilterModalOpen(false)
  }

  const handleIconButtonClick = () => {
    clearAllFilters()
    setKey(prevKey => prevKey + 1)
    history.push('/tickets')
  }

  if (
    !user.super &&
    user.profile !== 'admin' &&
    (!user.queues || user.queues.length === 0)
  ) {
    return (
      <div className={classes.ticketsWrapper}>
        <Paper
          elevation={0}
          variant="outlined"
          className={classes.ticketsWrapper}
        >
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3>Acesso Restrito</h3>
            <p>
              Você não possui departamentos associados ou permissões adequadas para
              acessar tickets.
            </p>
            <p>
              Entre em contato com o administrador para receber acesso aos departamentos
              necessários.
            </p>
          </div>
        </Paper>
      </div>
    )
  }

  return (
    <div key={key} className={classes.ticketsWrapper}>
      <Paper
        elevation={0}
        variant="outlined"
        className={classes.ticketsWrapper}
      >
        {!isChatOpen && (
          <Grid container className={classes.ticketsTabHeader}>
            <div className={classes.searchInputWrapper}>
              <SearchIcon className={classes.searchIcon} size={18} />
              <InputBase
                inputRef={searchInputRef}
                placeholder={i18n.t('tickets.search.placeholder')}
                type="search"
                id="searchInput"
                name="searchInput"
                onChange={handleSearch}
              />
              <Tooltip title={'Filtros'}>
                <IconButton
                  onClick={() => setFilterModalOpen(true)}
                  className={classes.actionButtonIcons}
                >
                  <Filter size={18} />
                </IconButton>
              </Tooltip>
            </div>
            {isMobile && (
              <Grid item xs={12}>
                <Tabs
                  value={tabOpen}
                  onChange={handleChangeTabOpen}
                  scrollButtons="scrollable"
                  variant="fullWidth"
                  indicatorColor="primary"
                  textColor="primary"
                  className={classes.tabMobile}
                >
                  {!areAllFiltersEmpty(activeFilters) && (
                    <Tab value={'filtered'} icon={<Filter size={20} />} />
                  )}
                  <Tab
                    value={'open'}
                    icon={
                      <Badge badgeContent={openCount}>
                        <Headset size={20} />
                      </Badge>
                    }
                    label="Ativos"
                  />

                  <Tab
                    value={'pending'}
                    icon={
                      <Badge badgeContent={pendingCount}>
                        <History size={20} />
                      </Badge>
                    }
                    label="Pendentes"
                  />

                  {showTabGroups && (
                    <Tab
                      value={'groups'}
                      icon={
                        <Badge badgeContent={groupsCount}>
                          <UsersRound size={20} />
                        </Badge>
                      }
                      label="Grupos"
                    />
                  )}

                  {showBotTab && (
                    <Tab
                      value={'chatbot'}
                      icon={
                        <Badge badgeContent={botCount}>
                          <Bot size={20} />
                        </Badge>
                      }
                      label="Bot"
                    />
                  )}

                  {showClosedTickets && (
                    <Tab
                      value={'closed'}
                      icon={
                        <Badge badgeContent={closedCount}>
                          <CircleX size={20} />
                        </Badge>
                      }
                      label="Fechados"
                    />
                  )}
                </Tabs>
              </Grid>
            )}
            {!isMobile && (
              <>
                <Tooltip title={'Atualizar'}>
                  <IconButton
                    onClick={handleIconButtonClick}
                    className={classes.actionButtonRefresh}
                  >
                    <RotateCw size={20} />
                  </IconButton>
                </Tooltip>
                <Tooltip title={'Novo Atendimento'}>
                  <IconButton
                    onClick={() => setNewTicketModalOpen(true)}
                    className={classes.actionButtonNewTicket}
                  >
                    <CirclePlus size={20} />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </Grid>
        )}

        {!areAllFiltersEmpty(activeFilters) && (
          <Grid container className={classes.filterActive}>
            {Object.entries(activeFilters).map(([type, values]) => {
              if (Array.isArray(values) && values.length > 0) {
                return values.map(value => (
                  <Chip
                    key={`${type}-${value}`}
                    label={`${getFilterDisplayValue(type, value)}`}
                    onDelete={() => removeFilter(type, value)}
                    className={classes.filterChip}
                    deleteIcon={<CircleX />}
                  />
                ))
              }
              if (values && !Array.isArray(values)) {
                return (
                  <Chip
                    key={type}
                    label={`${getFilterDisplayValue(type, values)}`}
                    onDelete={() => removeFilter(type, null)}
                    className={classes.filterChip}
                    deleteIcon={<CircleX />}
                  />
                )
              }
              return null
            })}
            {!areAllFiltersEmpty(activeFilters) && (
              <Chip
                label="Limpar todos"
                onDelete={clearAllFilters}
                className={classes.filterChip}
                deleteIcon={<CircleX />}
              />
            )}
          </Grid>
        )}
        {!isMobile && (
          <Grid container className={classes.closedButton}>
            <InputSwitch
              label="Fechados"
              size="small"
              name="closed"
              color="primary"
              checked={showClosedTickets}
              onChange={handleClosedSwitchChange}
            />
            {/* <InputSwitch
            label="Foco"
            size="small"
            name="foco"
            color="primary"
            checked={foco}
            onChange={handleFocoSwitchChange}
          /> */}
          </Grid>
        )}

        {!isMobile && (
          <Tabs
            value={tabOpen}
            onChange={handleChangeTabOpen}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            className={classes.tab}
          >
            {!areAllFiltersEmpty(activeFilters) && (
              <Tab
                value={'filtered'}
                icon={<Filter />}
                className={classes.tab}
              />
            )}
            <Tab
              label={`Ativos (${openCount})`}
              value={'open'}
              icon={
                <Badge
                  variant="dot"
                  invisible={!unreadTabs.open}
                  overlap="rectangular"
                  badgeContent=" "
                  classes={{
                    badge: classes.customGreenBadge
                  }}
                  aria-label={
                    unreadTabs.open
                      ? `Novas mensagens não lidas na aba Ativos, existem ${openCount} itens`
                      : `Itens ativos, total de ${openCount}`
                  }
                >
                  <Headset aria-hidden="true" />
                </Badge>
              }
              className={classes.tab}
            />
            <Tab
              label={`Pendentes (${pendingCount})`}
              value={'pending'}
              icon={
                <Badge
                  variant="dot"
                  invisible={!unreadTabs.pending}
                  overlap="rectangular"
                  badgeContent=""
                  classes={{
                    badge: classes.customGreenBadge
                  }}
                  aria-label={
                    unreadTabs.pending
                      ? 'Novas mensagens não lidas na aba Pendentes'
                      : 'Itens pendentes'
                  }
                >
                  <History size={20} />
                </Badge>
              }
              className={classes.tab}
            />
            {showTabGroups && (
              <Tab
                value={'groups'}
                icon={
                  <Badge
                    variant="dot"
                    invisible={!unreadTabs.groups}
                    overlap="rectangular"
                    badgeContent=""
                    aria-label={
                      unreadTabs.groups
                        ? 'Novas mensagens não lidas na aba Grupos'
                        : 'Itens grupos'
                    }
                    classes={{
                      badge: classes.customGreenBadge
                    }}
                  >
                    <UsersRound size={20} />
                  </Badge>
                }
                label={`Grupos (${groupsCount})`}
                className={classes.tab}
              />
            )}

            {showBotTab && (
              <Tab
                value={'chatbot'}
                label={`Bot (${botCount})`}
                icon={
                  <Badge
                    variant="dot"
                    invisible={!unreadTabs.bot}
                    overlap="rectangular"
                    badgeContent=""
                    aria-label={
                      unreadTabs.bot
                        ? 'Novas mensagens não lidas na aba Bot'
                        : 'Itens no bot'
                    }
                    classes={{
                      badge: classes.customGreenBadge
                    }}
                  >
                    <Bot size={20} />
                  </Badge>
                }
                aria-label="chatbot"
                className={classes.tab}
              />
            )}

            {showClosedTickets && (
              <Tab
                value={'closed'}
                label={`Fechados (${closedCount})`}
                icon={<CircleX />}
                aria-label="closed"
                className={classes.tab}
              />
            )}
          </Tabs>
        )}

        <Paper elevation={0} className={classes.ticketsBoxWrapper}>
          {isMobile && isChatOpen ? (
            <ChatMobile onClose={() => setIsChatOpen(false)} />
          ) : (
            <>
              {!areAllFiltersEmpty(activeFilters) && (
                <TicketsList
                  filteredTickets={filteredTickets}
                  searchParam={searchParam}
                  style={applyPanelStyle('filtered')}
                  setTabOpen={setTabOpen}
                />
              )}
              <TicketsList
                status="open"
                showAll={showAllTickets}
                searchParam={searchParam}
                selectedQueueIds={selectedQueueIds}
                updateCount={val => setOpenCount(val)}
                updateTotal={val => setOpenTotal(val)}
                updateUnreadStatus={(tabKey, hasUnread) => {
                  setUnreadTabs(prev => ({ ...prev, [tabKey]: hasUnread }))
                }}
                style={applyPanelStyle('open')}
                setTabOpen={setTabOpen}
                groupActionButtons={!showTabGroups}
                groups={false}
                showTabGroups={showTabGroups}
              // filteredTickets={filteredTickets}
              />
              <TicketsList
                status="pending"
                searchParam={searchParam}
                selectedQueueIds={selectedQueueIds}
                updateCount={val => setPendingCount(val)}
                updateTotal={val => setOpenTotal(val)}
                updateUnreadStatus={(tabKey, hasUnread) => {
                  setUnreadTabs(prev => ({ ...prev, [tabKey]: hasUnread }))
                }}
                style={applyPanelStyle('pending')}
                setTabOpen={setTabOpen}
                // groupActionButtons={!showTabGroups}
                showTabGroups={showTabGroups}
              />
              {showBotTab && (
                <TicketsList
                  searchParam={searchParam}
                  updateCount={val => setBotCount(val)}
                  updateTotal={val => setOpenTotal(val)}
                  updateUnreadStatus={(_status, hasUnread) => {
                    setUnreadTabs(prev => ({ ...prev, chatbot: hasUnread }))
                  }}
                  style={applyPanelStyle('chatbot')}
                  setTabOpen={setTabOpen}
                  // groupActionButtons={!showTabGroups}
                  chatbots={true}
                  showAll={true}
                  selectedQueueIds={selectedQueueIds}
                // showTabGroups={showTabGroups}
                />
              )}

              {showTabGroups && (
                <TicketsList
                  searchParam={searchParam}
                  updateCount={val => setGroupsCount(val)}
                  updateTotal={val => setOpenTotal(val)}
                  updateUnreadStatus={(_status, hasUnread) => {
                    setUnreadTabs(prev => ({ ...prev, groups: hasUnread }))
                  }}
                  style={applyPanelStyle('groups')}
                  setTabOpen={setTabOpen}
                  // groupActionButtons={!showTabGroups}
                  groups={true}
                  showAll={true}
                  selectedQueueIds={selectedQueueIds}
                  showTabGroups={showTabGroups}
                />
              )}

              {showClosedTickets && (
                <div style={applyPanelStyle('closed')}>
                  <TicketsList
                    status="closed"
                    searchParam={searchParam}
                    updateCount={val => setClosedCount(val)}
                    updateTotal={val => setOpenTotal(val)}
                    style={applyPanelStyle('closed')}
                    setTabOpen={setTabOpen}
                    // groupActionButtons={!showTabGroups}
                    showAll={true}
                    selectedQueueIds={selectedQueueIds}
                    showTabGroups={showTabGroups}
                  />
                </div>
              )}
            </>
          )}
        </Paper>

        <NewTicketModal
          modalOpen={newTicketModalOpen}
          onClose={ticket => {
            handleCloseOrOpenTicket(ticket)
          }}
        />

        <FilterTicketModal
          modalOpen={filterModalOpen}
          onClose={() => {
            handleCloseOrOpenFilter()
          }}
          onFilter={handleFilter}
        />

        {isMobile && (
          <BottomNavbar
            currentTab={tabOpen}
            onTabChange={value => {
              setIsChatOpen(false) // Fecha o chat se clicar em outra aba de tickets
              setTabOpen(value)
            }}
            onNewTicket={() => setNewTicketModalOpen(true)}
            showGroups={showTabGroups}
            isChatOpen={isChatOpen}
            onOpenInternalChat={val => setIsChatOpen(val)} // Controla o estado aqui
            counts={{
              open: openCount,
              pending: pendingCount,
              bot: botCount,
              closed: closedCount
            }}
          />
        )}
      </Paper>
    </div>
  )
}

export default TicketsManagerTabs
